import React from "react";

import { utils } from "../../utils/globalVariables";
import { numberWithComma, getValuePropInObj } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const DiscountSpecialData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama'
                stateContent={stateData.diskon_code_prefix}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diskon'
                stateContent={
                    stateData.diskon_type === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(stateData.diskon_value))}` : `${Number(stateData.diskon_value)}%`
                }
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Dari'
                stateContent={getValuePropInObj(utils.discountDeductedFrom, 'value', stateData.diskon_deducted_from, 'label', ' - ')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default DiscountSpecialData;